<template>
  <div class="card">
    <div class="row reverse-info-menu">
      <div class="col-xs-12 col-md-4">
        <div class="card aligner-wrapper">
          <div class="card-body">
            <div class="absolute left top bottom h-60 v-strock-2 bg-success"></div>
            <p class="text-muted mb-2">{{ overallValueCaption }}</p>
            <div class="d-xl-flex align-items-center">
              <h1 class="font-weight-medium mb-2">{{ `${overallValue}` }}</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card aligner-wrapper">
          <div class="card-body">
            <div class="absolute left top bottom h-60 v-strock-2 bg-success"></div>
            <p class="text-muted mb-2">{{ currentValueCaption }}</p>
            <div class="d-xl-flex align-items-center">
              <h1 class="font-weight-medium mb-2">{{ `${currentValue}` }}</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card aligner-wrapper">
          <div class="card-body w-100">
            <b-form-group
              label-class="text-muted"
              :label="$t('dashboards.energyConsumption.discreteness')"
              label-for="discretePeriod"
            >
              <model-select
                id="discretePeriod"
                v-model="aggreagationPeriod"
                :options="aggregationPeriodList"
              ></model-select>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-if="loading" class="dot-opacity-loader loader-index">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div id="energyChartContainer" style="height: 300px"></div>
    </div>
  </div>
</template>

<script>
import energyConsumptionPeriodStats from '@/api/energy/energyConsumptionPeriodStats.gql';
import energyConsumptionPeriodValues from '@/api/energy/energyConsumptionPeriodValues.gql';

import moment from 'moment';
import CanvasJS from '@/plugins/canvasjs.min';
const canvas = CanvasJS.Chart ? CanvasJS : window.CanvasJS;

export default {
  name: 'EnergyConsumptionPlot',
  props: {
    deviceId: String,
    period: Object,
    tabPeriodText: String,
    minPeriod: Number,
    maxPeriod: Number,
  },
  apollo: {
    values: {
      query: energyConsumptionPeriodValues,
      variables() {
        return {
          deviceId: this.deviceId,
          period: this.period,
          aggregation: this.aggreagationPeriod,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        return (queryData || {}).energyConsumptionPeriodValues || [];
      },
      skip() {
        return !this.deviceId;
      },
    },
    stats: {
      query: energyConsumptionPeriodStats,
      variables() {
        return {
          deviceId: this.deviceId,
          period: this.period,
        };
      },
      pollInterval: 30000,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        return (queryData || {}).energyConsumptionPeriodStats || {};
      },
      skip() {
        return !this.deviceId;
      },

      fetchPolicy: 'cache-and-network',
    },
  },
  data: () => {
    return {
      aggreagationPeriod: 'HOUR',
    };
  },
  computed: {
    aggreagationPeriodLocal() {
      return localStorage.getItem('aggreagationPeriod');
    },
    aggregationPeriodList() {
      return [
        {
          text: '5 ' + this.$t('notifications.minutes'),
          value: 'MINUTES_5',
        },
        {
          text: '15 ' + this.$t('notifications.minutes'),
          value: 'MINUTES_15',
        },
        { text: '30 ' + this.$t('notifications.minutes'), value: 'MINUTES_30' },
        {
          text: '60 ' + this.$t('notifications.minutes'),
          value: 'HOUR',
        },
      ];
    },
    start() {
      return this.rangeMin
        ? moment(this.rangeMin).format()
        : this.minPeriod
        ? moment(this.minPeriod).format()
        : this.period.dateStart;
    },
    end() {
      return this.rangeMax
        ? moment(this.rangeMax).format()
        : this.maxPeriod
        ? moment(this.maxPeriod).format()
        : this.period.dateEnd;
    },
    currentValueCaption() {
      return this.$t('dashboards.energyConsumption.currentValue') + this.tabPeriodText;
    },
    overallValueCaption() {
      return this.$t('dashboards.energyConsumption.overallValue');
    },
    unitName() {
      return this.$t('dashboards.kvtch');
      // return (
      //   (((this.sensorData || {}).type || {}).measurementUnit || {})
      //     .shortName || ''
      // )
    },

    overallValue() {
      return this.statsLoading
        ? '...'
        : this.stats
        ? `${this.formatNumber((this.stats.overallConsumptionByNow || 0) / 1000)} ${this.unitName}`
        : this.$t('dashboards.noData');
    },
    currentValue() {
      return this.statsLoading
        ? '...'
        : this.stats
        ? `${this.formatNumber((this.stats.consumptionInPeriod || 0) / 1000)} ${this.unitName}`
        : this.$t('dashboards.noData');
    },
    dataSeries() {
      const points = this.values?.map((i) => {
        return {
          x: new Date(moment(i.timeStamp).valueOf()),
          y: i.value / 1000,
        };
      });
      const [lastItem] = points ? points.slice(-1) : '';
      if (lastItem) {
        points.push({
          x: new Date(moment(lastItem.x).add(1, 'h').valueOf()),
          y: lastItem.y,
        });
      }
      return [
        {
          type: 'splineArea',
          color: '#00d25b',
          dataPoints: points,
        },
      ];
    },
    chartOptionsCj() {
      const vm = this;
      return {
        theme: 'dark2',
        zoomEnabled: true,
        zoomType: 'x',
        backgroundColor: 'rgb(25, 28, 36)',
        axisX: {
          minimum: vm.minDate,
          maximum: vm.maxDate,
          lineThickness: 1,
          gridThickness: 0,
          lineColor: 'grey',
          labelFontColor: 'grey',
          tickColor: 'grey',
          labelMaxWidth: 40,
          labelFontSize: 10,
          labelFormatter: function (e) {
            const label = moment(e.value).locale(vm.locale).format('DD MMM HH:mm');

            return label;
          },
        },
        axisY: {
          minimum: 0,
          lineThickness: 0,
          tickThickness: 0,
          gridColor: '#000000',
          labelFontColor: 'grey',
          includeZero: true,
        },
        toolTip: {
          contentFormatter: function (e) {
            const value = `${vm.formatNumber(e.entries[0].dataPoint.y)} ${vm.unitName}`;
            const start = moment(e.entries[0].dataPoint.x).locale(vm.locale).format('DD MMM HH:mm');
            return `${start}: <b><font color="green">${value}</font></b>`;
          },
        },
        rangeChanged: function (e) {
          vm.rangeMin = e.axisX[0].viewportMinimum;
          vm.rangeMax = e.axisX[0].viewportMaximum;
        },
        data: vm.dataSeries,
      };
    },
    minDate() {
      return this.minPeriod
        ? this.minPeriod
        : this.period.dateStart
        ? new Date(this.period.dateStart).getTime()
        : new Date().getTime();
    },
    maxDate() {
      return this.maxPeriod
        ? this.maxPeriod
        : this.period.dateEnd
        ? new Date(this.period.dateEnd).getTime()
        : new Date().getTime();
    },
    loading() {
      return this.$apollo.queries.values.loading;
    },
    statsLoading() {
      return this.$apollo.queries.stats.loading;
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    minPeriod() {
      this.updateChart();
    },
    aggreagationPeriod(newVal) {
      localStorage.setItem('aggreagationPeriod', newVal);
      this.updateChart();
    },
  },
  mounted() {
    this.aggreagationPeriod = this.aggreagationPeriodLocal
      ? this.aggreagationPeriodLocal
      : this.aggreagationPeriod;
  },
  updated() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      const chartId = 'energyChartContainer';
      if (document.getElementById(chartId)) {
        this.rangeMin = null;
        this.rangeMax = null;
        this.chart = new canvas.Chart(chartId, this.chartOptionsCj);
        this.chart.render();
      }
    },
    formatNumber(v) {
      return Number(v.toPrecision(4)).toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
.loader-index {
  z-index: 5;
}
.form-control#discretePeriod {
  color: black;
}
</style>
